import DateDisplay from "components/datetime/DateDisplay";
import {useTranslation} from "react-i18next";

const PrevOrders = ({item, showPreview, ChoicesStatus, ChoicesOrigin}) => {
    const {t: _Tt} = useTranslation("tables");

    if (!item || Object.keys(item).length === 0) return null;

    return (
        <div className={`col preview-row ${showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{width: "300px"}}>
                        <div className="preview-header">
                            <div className="preview-title">
                                <label>Orden #{item.id}</label>
                                <div className="preview-subtitle">{item.task_data?.name || '-'}</div>
                            </div>
                        </div>

                        <div className="preview-item">
                            <label>Programación</label>
                            <div className="preview-input">{item.programming_data?.name || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Incidencia</label>
                            <div className="preview-input">{item.incidence_data?.name || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Programada</label>
                            <div className="preview-input">{item.scheduled_at ? <DateDisplay date={item.scheduled_at} format="DD-MM-YYYY HH:mm" title={false} /> : '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Estado</label>
                            <div className="preview-input">{ChoicesStatus[item.status] || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Origen</label>
                            <div className="preview-input">{ChoicesOrigin[item.origin] || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Creado por</label>
                            <div className="preview-input">{item.created_by_email || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Responsable (orden)</label>
                            <div className="preview-input">{item.order_leader_email  || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Responsable (tarea)</label>
                            <div className="preview-input">{item.task_leader_email || '-'}</div>
                        </div>

                        <div className="preview-item">
                            <label>Creado</label>
                            <div className="preview-input">{item.created_at ? <DateDisplay date={item.created_at} format="DD-MM-YYYY HH:mm" title={false} /> : '-'}</div>
                        </div>

                        {item.description ? (
                            <div className="preview-item">
                                <label>Descripción</label>
                                <div className="preview-input" style={{whiteSpace: 'pre-wrap'}}>{item.description}</div>
                            </div>
                        ) : null}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrevOrders;
